import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import Navigation from './Navigation';
import MyTranscription from './MyTranscription';
import Login from './Login';
import Signup from './Signup';
import Settings from './SettingPage';
import TopBar from './Topbar';
import { supabase } from './supabaseClient';
import MeetingDetail from './MeetingDetail';
import PaymentSuccess from './PaymentSuccess';
import PaymentFail from './PaymentFail';
import PrivacyPolicy from './privacy';
import AgentCreate from './AgentCreate';
import AgentList from './AgentList';
import AppFooter from './Footer';
import Terms from './term';
import NotFound from './NotFound';
import HowToUse from './HowToUse';
import AcceptInvitation from './AcceptInvitation';
import Subscription from './Subscription';
import Redeem from './Redeem';
import ReactGA from 'react-ga4';

// Initialize GA4 with your measurement ID
ReactGA.initialize('G-8L7W6CNNL2'); // Replace with your GA4 measurement ID

// Create a component to track page views
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return null;
}

const { Content } = Layout;

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentMeetingId, setCurrentMeetingId] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
      setLoading(false);
    };

    fetchUser();

    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  // const handleStartRecording = (pastMeetingUrl) => {
  //   // 녹음 시작 로직 구현
  //   console.log('녹음 시작:', pastMeetingUrl);
  //   // 여기에 실제 녹음 시작 및 미팅 생성 로직을 추가해야 합니다.
  // };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <PageTracker />
      <Layout style={{ height: '100vh' }}>  {/* minHeight를 height로 변경 */}
        <Navigation user={user} />
        <Layout style={{
          marginLeft: 250,
          marginTop: 64,
          height: '100vh',      // 추가
          overflow: 'hidden'    // 추가
        }}>
          <TopBar
            user={user}
            currentMeetingId={currentMeetingId}
            setCurrentMeetingId={setCurrentMeetingId}
          />
          <Content style={{
            padding: '24px',
            height: 'calc(100vh - 64px)',  // 수정: TopBar 높이(64px)를 뺀 높이
            overflow: 'auto'               // 추가
          }}>            <Routes>
              <Route
                path="/"
                element={user ? <MyTranscription user={user} /> : <Navigate to="/login" />}
              />
              <Route
                path="/login"
                element={user ? <Navigate to="/" /> : <Login />}
              />
              <Route
                path="/signup"
                element={user ? <Navigate to="/" /> : <Signup />}
              />
              <Route
                path="/settings"
                element={user ? <Settings user={user} /> : <Navigate to="/login" />}
              />
              <Route
                path="/success"
                element={user ? <PaymentSuccess /> : <Navigate to="/login" />}
              />
              <Route
                path="/fail"
                element={user ? <PaymentFail /> : <Navigate to="/login" />}
              />

              <Route
                path="/settings"
                element={user ? <Settings user={user} /> : <Navigate to="/login" />}
              />
              <Route
                path="/meeting/:id"
                element={user ? <MeetingDetail user={user} /> : <Navigate to="/login" />}
              />
              <Route
                path="/agent/create"
                element={user ? <AgentCreate user={user} /> : <Navigate to="/login" />}
              />
              <Route
                path="/agent/list"
                element={user ? <AgentList user={user} /> : <Navigate to="/login" />}
              />
              <Route
                path="/privacy"
                element={<PrivacyPolicy />}  // This route doesn't require authentication
              />
              <Route path="/terms"
                element={<Terms />}>
              </Route>
              <Route
                path="/how-to-use"
                element={<HowToUse />}
              />
              <Route
                path="/subscription"
                element={user ? <Subscription user={user} /> : <Navigate to="/login" />}
              />
              <Route
                path="/redeem"
                element={user ? <Redeem user={user} /> : <Navigate to="/login" />}
              />
              <Route path="/accept-invitation/:invitationId" element={user ? <AcceptInvitation user={user} /> : <Navigate to="/login" />} />
              <Route path="*" element={<NotFound />} />

            </Routes>
          </Content>
          <AppFooter />
        </Layout>
      </Layout>
    </Router >
  );
};

export default App;